import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('prtRptStore', Object.keys(getters)),
	...mapState('prtRptStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('prtRptStore', Object.keys(actions)),
	...mapMutations('prtRptStore', Object.keys(mutations))
};
